module.exports = __webpack_public_path__ + "img/icon_dashboard_logic.676b3a4f.svg";